import axios from "axios";
import apis from "../../../../lib/apis/apis";
import { apiHeaders } from "../../../../lib/apiHeader";
import { mockGcalStatus, mockGcalConnect, mockGcalDisconnect } from "./mockGcalData";

// Flip to false when the Laravel endpoints from the spec's §6 contract ship.
export const USE_GCAL_MOCKS = true;

const delay = (data, ms = 400) =>
  new Promise((resolve) => setTimeout(() => resolve(data), ms));

const get = async (url, params) => {
  const response = await axios.get(url, { params, headers: apiHeaders() });
  if (response?.data?.success === "true") return response.data.data;
  throw new Error(response?.data?.message || "Request failed");
};

const post = async (url, payload) => {
  const response = await axios.post(url, payload, { headers: apiHeaders() });
  if (response?.data?.success === "true") return response.data.data;
  throw new Error(response?.data?.message || "Request failed");
};

export const gcalApi = {
  getStatus: async (params) =>
    USE_GCAL_MOCKS ? delay(mockGcalStatus(params)) : get(apis.gcal_oauth_status, params),
  connect: async (payload) =>
    USE_GCAL_MOCKS ? delay(mockGcalConnect(payload), 900) : post(apis.gcal_oauth_connect, payload),
  disconnect: async (payload) =>
    USE_GCAL_MOCKS ? delay(mockGcalDisconnect(payload)) : post(apis.gcal_oauth_disconnect, payload),
};
